import React from 'react';
import { ResumeViewContext } from './context';

export const useViewResume = () => {
  const { view } = React.useContext(ResumeViewContext);
  return [view];
};
